import React, { useCallback, useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import { INPUT } from "shared/labels";
import Select from "components/Controls/Select";
import * as styles from "./styles.module.scss";
const SelectInput = ({ value, undefinedReadonlyPlaceholder = true, placeholder, items, readonly, disabled, className, componentClasses, onChange, onBlur, itemRenderer, selectButtonProps, ...props }) => {
    const [isPristine, setIsPristine] = useState(true);
    const [itemToSave, setItemToSave] = useState();
    const [internalValue, setInternalValue] = useState();
    const placeholderText = useMemo(() => {
        if (readonly && undefinedReadonlyPlaceholder) {
            return INPUT.UNDEFINED;
        }
        return placeholder;
    }, [placeholder, readonly, undefinedReadonlyPlaceholder]);
    const internalOnChange = useCallback((item) => {
        setIsPristine(false);
        setItemToSave(item);
    }, []);
    const onClosing = useCallback(() => {
        if (itemToSave) {
            onChange(itemToSave);
        }
        onBlur && onBlur();
        setItemToSave(undefined);
    }, [itemToSave, onBlur, onChange]);
    useEffect(() => {
        const valueToSave = typeof value === "string" || typeof value === "number"
            ? items?.find((item) => item.value === value)
            : value;
        if (isPristine) {
            setInternalValue(valueToSave);
        }
        else {
            setInternalValue(valueToSave);
        }
    }, [isPristine, items, value]);
    return (React.createElement(Select, { ...props, value: internalValue, placeholder: placeholderText, items: items, onClosing: onClosing, onChange: internalOnChange, viewMode: readonly, disabled: disabled, itemRenderer: itemRenderer, classes: {
            ...componentClasses,
            root: classNames(className, componentClasses?.root),
            selectButton: classNames(styles["select-button"], {
                [styles["select-button-readonly-empty"]]: readonly && !internalValue?.label,
            }, componentClasses?.selectButton),
        }, excludeValidation: true, selectButtonProps: {
            ...selectButtonProps,
            value: internalValue?.label,
        } }));
};
export default SelectInput;
